import { CheckOutlined, CopyOutlined } from '@ant-design/icons';
import { useState } from 'react';
import Styles from '../../Styles.module.scss';
import { useGetLatestReleaseQuery } from '../../store/DistService';

export function DistHead() {
    const installCommand = `curl -fsSL https://raw.githubusercontent.com/model-park/cli/master/install.sh | sh`;

    const [copied, setCopied] = useState(false);
    const { data: latestRelease } = useGetLatestReleaseQuery();

    const handleCopy = async () => {
        await navigator.clipboard.writeText(installCommand);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    return (
        <div className={Styles.Hero}>
            {latestRelease && (
                <div className={Styles.VersionBadge}>
                    <span>{latestRelease.tag_name}</span>
                </div>
            )}

            <h1 className={Styles.HeroTitle}>ModelPark CLI</h1>

            <p className={Styles.HeroTagline}>Expose local apps and APIs to the internet in seconds</p>

            <div className={Styles.QuickInstall}>
                <div className={Styles.QuickInstallLabel}>Quick Install <span style={{ fontWeight: 400, fontSize: '0.85em', opacity: 0.7 }}>(macOS / Linux)</span></div>
                <div className={Styles.CodeBlockInline}>
                    <code>{installCommand}</code>
                    <button
                        onClick={handleCopy}
                        style={{
                            background: 'transparent',
                            border: 'none',
                            cursor: 'pointer',
                            color: copied ? '#6ae942' : '#94a3b8',
                            padding: '4px',
                            display: 'flex',
                            alignItems: 'center',
                        }}
                        title={copied ? 'Copied!' : 'Copy to clipboard'}
                    >
                        {copied ? <CheckOutlined /> : <CopyOutlined />}
                    </button>
                </div>
                <div style={{ fontSize: '0.8em', opacity: 0.6, marginTop: 6 }}>
                    Windows users: see the <a href="#installation" style={{ color: 'inherit', textDecoration: 'underline' }}>installation section</a> below for PowerShell instructions.
                </div>
            </div>
        </div>
    );
}
